import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomButtonComponent } from './custom-button/custom-button.component';
import { ButtonModule } from 'primeng/button';
import { CustomInputComponent } from './custom-input/custom-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CustomCheckboxComponent } from './custom-checkbox/custom-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { CustomCalendarComponent } from './custom-calendar/custom-calendar.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { BiggerPictureDatePipe } from '../../pipes/bigger-picture-date.pipe';
import { CustomRadioButtonComponent } from './custom-radio-button/custom-radio-button.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MultiSelectModule } from 'primeng/multiselect';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CustomListboxComponent } from './custom-listbox/custom-listbox.component';
import { CustomTextAreaComponent } from './custom-textarea/custom-textarea.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    ButtonModule,
    CalendarModule,
    InputTextModule,
    InputSwitchModule,
    InputSwitchModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    DropdownModule,
    CalendarModule,
    RadioButtonModule,
    MatRadioModule,
    MatIconModule,
    InputTextareaModule,
    MultiSelectModule
  ],
  declarations: [CustomButtonComponent, CustomInputComponent, CustomCheckboxComponent, CustomDropdownComponent, CustomCalendarComponent, CustomRadioButtonComponent, CustomListboxComponent, CustomTextAreaComponent],
  exports: [
    CustomButtonComponent,
    CustomInputComponent,
    CustomCheckboxComponent,
    CustomDropdownComponent,
    CustomCalendarComponent,
    CustomRadioButtonComponent,
    CustomListboxComponent,
    CustomTextAreaComponent
  ],
  providers: [BiggerPictureDatePipe]
})
export class CustomFormModule {
}
